const joinClasses = (classes: string[]) => classes.join(' ');

export default joinClasses;
